// eslint-disable-next-line no-param-reassign
export const calculateChatTurns = (turn: number) => ++turn;
